import React from "react";
import { Button } from "../../button/button.jsx";
import {
  showSSRHydrationWarning,
  isPropEmpty,
} from "../../utils/SSR/showSSRHydrationWarning";
import { useSSR } from "../../utils/SSR/useSSR";
import { PaypalTypes } from "../types/paypal.types";

export const Paypal = ({
  description,
  button,
}: PaypalTypes): React.ReactElement => {
  useSSR(
    () =>
      isPropEmpty(button.id) && showSSRHydrationWarning("button.id", "Paypal")
  );
  return (
    <>
      <p>{description}</p>
      <Button {...button} />
    </>
  );
};

Paypal.displayName = "Paypal";
